/**
 * 一键生成「上传自有图」的本地压缩:长边 ≤1600px、JPEG,原始字节超 650KB 逐级降质量(宿主上传走 nginx 约 1MB 上限,
 * base64 膨胀约 1/3)。口径与 `host/CropUploadDialog` 一致,只是不裁剪。回裸 base64(不带 dataURL 前缀)。
 */
const UPLOAD_LIMIT = 650_000;
const MAX_SIDE = 1600;

function readAsDataUrl(file: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(String(r.result));
    r.onerror = () => reject(new Error("读取文件失败"));
    r.readAsDataURL(file);
  });
}

function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("无法解析该图片(请用 JPG/PNG)"));
    img.src = src;
  });
}

const toJpeg = (canvas: HTMLCanvasElement, q: number) =>
  new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, "image/jpeg", q));

export async function compressImage(file: File): Promise<string> {
  const src = await readAsDataUrl(file);
  const img = await loadImage(src);
  const scale = Math.min(1, MAX_SIDE / Math.max(img.naturalWidth, img.naturalHeight, 1));
  const canvas = document.createElement("canvas");
  canvas.width = Math.max(1, Math.round(img.naturalWidth * scale));
  canvas.height = Math.max(1, Math.round(img.naturalHeight * scale));
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("图片处理失败");
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
  let blob = (await toJpeg(canvas, 0.9)) ?? null;
  if (!blob) throw new Error("图片处理失败");
  for (const q of [0.8, 0.65, 0.5]) {
    if (blob.size <= UPLOAD_LIMIT) break;
    blob = (await toJpeg(canvas, q)) ?? blob;
  }
  const data = await readAsDataUrl(blob);
  return data.split(",")[1] ?? data;
}
